/**
 * Configuração de marca (brand) — fonte única para nome, domínios, URLs e contatos.
 *
 * Tudo é parametrizável por variáveis de ambiente REACT_APP_BRAND_* (build/deploy-time).
 * Quando uma variável não é definida, o default mantém a marca "ecompay", de modo que o
 * comportamento atual é preservado sem nenhuma configuração extra.
 *
 * Para trocar a marca: defina as REACT_APP_BRAND_* no .env (ou no ambiente de build) e,
 * opcionalmente, ajuste o tema em src/themes/ (ver REACT_APP_BRAND_THEME).
 */

const fallback = (value, def) =>
  value === undefined || value === null || value === '' ? def : value;

// Identidade
export const BRAND_NAME = fallback(process.env.REACT_APP_BRAND_NAME, 'EcomPay');
export const BRAND_LEGAL_NAME = fallback(
  process.env.REACT_APP_BRAND_LEGAL_NAME,
  'PLATAFORMA ECOMPAY'
);

// Domínio e URLs públicas
export const BRAND_PRIMARY_DOMAIN = fallback(
  process.env.REACT_APP_BRAND_PRIMARY_DOMAIN,
  'ecompay.app'
);
export const BRAND_SITE_URL = fallback(
  process.env.REACT_APP_BRAND_SITE_URL,
  `https://${BRAND_PRIMARY_DOMAIN}`
);
export const BRAND_GO_URL = fallback(
  process.env.REACT_APP_BRAND_GO_URL,
  `https://go.${BRAND_PRIMARY_DOMAIN}`
);
export const BRAND_DASHBOARD_URL = fallback(
  process.env.REACT_APP_BRAND_DASHBOARD_URL,
  `https://dashboard.${BRAND_PRIMARY_DOMAIN}`
);
export const BRAND_CHECKOUT_URL = fallback(
  process.env.REACT_APP_BRAND_CHECKOUT_URL,
  `https://checkout.${BRAND_PRIMARY_DOMAIN}`
);
export const BRAND_SECURE_URL = fallback(
  process.env.REACT_APP_BRAND_SECURE_URL,
  `https://secure.${BRAND_PRIMARY_DOMAIN}`
);

// Contatos
export const BRAND_SUPPORT_EMAIL = fallback(
  process.env.REACT_APP_BRAND_SUPPORT_EMAIL,
  `suporte@${BRAND_PRIMARY_DOMAIN}`
);
export const BRAND_CONTACT_EMAIL = fallback(
  process.env.REACT_APP_BRAND_CONTACT_EMAIL,
  `contato@${BRAND_PRIMARY_DOMAIN}`
);

// Logo (texto alternativo). O asset em si vem de src/assets/svg/ — ver etapa de logo.
export const BRAND_LOGO_ALT = fallback(process.env.REACT_APP_BRAND_LOGO_ALT, BRAND_NAME);

// Entidade jurídica licenciante (usada nos documentos legais — termos/políticas).
// Os defaults preservam exatamente o conteúdo atual dos documentos. Valores informados
// em HTML devem ser HTML-safe (os documentos legais são renderizados como HTML).
export const BRAND_LICENSOR_ENTITY = fallback(
  process.env.REACT_APP_BRAND_LICENSOR_ENTITY,
  'E-COM COMUNICA&Ccedil;&Otilde;ES LTDA'
);
export const BRAND_LICENSOR_TAX_ID = fallback(
  process.env.REACT_APP_BRAND_LICENSOR_TAX_ID,
  '07.722.534/0001-70'
);

const brand = {
  BRAND_NAME,
  BRAND_LEGAL_NAME,
  BRAND_PRIMARY_DOMAIN,
  BRAND_SITE_URL,
  BRAND_GO_URL,
  BRAND_DASHBOARD_URL,
  BRAND_CHECKOUT_URL,
  BRAND_SECURE_URL,
  BRAND_SUPPORT_EMAIL,
  BRAND_CONTACT_EMAIL,
  BRAND_LOGO_ALT,
  BRAND_LICENSOR_ENTITY,
  BRAND_LICENSOR_TAX_ID,
};

export default brand;
